//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';
import { OnlineResourceType } from './Enums';

export class OnlineResourcesSearchOptions extends ItemBase {
    IDs: string[] = [];
    StudentIDs: string[] = [];
    OmitIDs: string[] = [];
    Hidden: boolean | null = null;
    SearchText: string | null = null;
    ContainingFolderID: string | null = null;
    AncestralFolderID: string | null = null;
    SpaceID: string | null = null;
    OnlineResourceTypes: OnlineResourceType[] = [];

    constructor(initializer?: Partial<OnlineResourcesSearchOptions>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static readonly ClassName: string = "OnlineResourcesSearchOptions";
}
